/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';
import { OutletProps } from './types';

export const DefaultOutlet = (props: OutletProps): ReactElement | null => {
  return <></>;
};
